import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'
import Organisation from '@/api/Dara/Organisation'
import OrganisationSettings from '@/api/Dara/OrganisationSettings'
import { organisationKeys } from '@/composable/queries/keys'

interface UpdateData {
  organisationSettingsId: number;
  formData: object;
}

export const useOrganisationSettingsQuery = (
  organisationId: Ref<number>,
  enabled: Ref<boolean>,
) =>
  useQuery({
    queryKey: organisationKeys.settings(organisationId),
    queryFn: () => Organisation.getOrganisationSettings(organisationId.value),
    enabled,
  })

export const useUpdateOrganisationSettings = (
  organisationId: number,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (updateData: UpdateData) => OrganisationSettings.update(updateData.organisationSettingsId, updateData.formData),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: organisationKeys.settings(ref(organisationId)),
      })
    },
  })
}
